import {makeStyles} from '@material-ui/core/styles';

export default () =>{
  
    let useStyles = makeStyles({
      column:{
        display:"flex",
        justifyContent:"space-around",
        height:"100vh"
      },
      RowLeft:{
        width:"50%",
        textAlign:"center",
      },
      invoiceapp:{
        marginTop:"100px",
        color:"#828282",
        fontSize:"45px"
      },
      RowRight:{
        width:"50%",
        background:"#003c70",
        color:"white",
        textAlign:"center",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      login:{
        fontSize:"30px",
        marginBottom: 50
      },
      inputtext:{
        width:"450px",
        height: 35,
        marginTop:"20px",
        marginBottom:"20px",
        outline:"none",
        fontSize:15,
        paddingLeft:"19px",
        "&::placeholder": {
          color:"#d5d5d5",
          paddingLeft:"0px"
         }
      },
      buttonlog:{
        color:"white",
        background:"#053158",
        width:"200px",
        height:"50px",
        borderRadius:"30px",
        textTransform:"none",
        boxShadow: '0 0 12px #00000055',
        marginTop: 30
      }
    })
    return useStyles();
}
